import $ from 'jquery'
//import './partial/isotope.js'
import './partial/animate.js'
import './partial/backgrounds.js'
import './partial/forms.js'
import './partial/google_consent.js'
import './partial/header.js'
import './partial/map.js'
import './partial/newsletter.js'
import './partial/links.js'
import './partial/preload.js'
import './partial/slider.js'
//import './partial/testimonials'
import './utils/svg.js'
//import './partial/blotting_text.js'

/**
 * Lets init Foundation scripts.
 */

$(document).foundation();

/**
* other functions
*/

$(document).ready(function($) {
  //console.log('eo')
});




// WEBPACK FOOTER //
// ./resources/assets/js/app.js